// EL ESTADO DEL WORKER, A LA VISTA · DIRECTRIZ-PWA F1 (11 oct 2026).
//
// Hasta hoy `main.jsx` registraba el worker con `.catch(() => {})`: si
// fallaba, nadie se enteraba y la app simplemente no abría sin señal. Aquí
// se anota qué pasó —registrado, listo, falló, no disponible— en memoria,
// se avisa a quien escuche (`tego:worker`) y la pantalla «Instalar TEGO en
// tu teléfono» lo enseña. Sin sesión, sin API, sin red: no filtra nada de
// nadie.
import { useSyncExternalStore } from 'react';

/** @type {{ estado: 'pendiente'|'registrado'|'listo'|'fallo'|'no-disponible', motivo?: string, alcance?: string }} */
let actual = { estado: 'pendiente' };
const oyentes = new Set();

// NUNCA SE BAJA DE «LISTO» A «REGISTRADO» (auditoría F1, P1-1, 11 oct 2026).
// En toda visita después de la primera `navigator.serviceWorker.ready`
// resuelve ANTES que `register()` —ya hay un worker activo; `register()`
// espera a bajar sw.js y compararlo—, así que «registrado» llegaba después
// y pisaba «listo»: la pantalla se quedaba en «Preparándose para abrir sin
// señal…» con el indicador girando para siempre. Medido en Chromium: visita
// 1 «registrado > listo»; visitas 2, 3 y 4 «listo > registrado». El alcance
// sí se anota; el estado no retrocede.
const RETROCEDE = (de, a) => de === 'listo' && a === 'registrado';

export function anotarWorker(cambio) {
  const estado = RETROCEDE(actual.estado, cambio.estado) ? actual.estado : cambio.estado;
  actual = { ...actual, ...cambio, estado };
  if (cambio.estado === 'fallo') {
    // En consola, para soporte. El usuario lo ve en la pantalla de instalar.
    console.warn(`[TEGO] la app no quedó lista para abrir sin señal: ${cambio.motivo || 'sin detalle'}`);
  }
  oyentes.forEach((f) => f());
  if (typeof window !== 'undefined' && typeof CustomEvent === 'function') {
    window.dispatchEvent(new CustomEvent('tego:worker', { detail: actual }));
  }
}

export const leerWorker = () => actual;

const suscribirWorker = (f) => { oyentes.add(f); return () => oyentes.delete(f); };

/** El estado del worker, reactivo. */
export function useEstadoWorker() {
  return useSyncExternalStore(suscribirWorker, leerWorker, leerWorker);
}

/* Solo para pruebas: volver al arranque. */
export function _reiniciarWorker() {
  actual = { estado: 'pendiente' };
  oyentes.forEach((f) => f());
}
